const featuresEn = {
  "feat.title": "Features",
  "feat.description": "Built-in features your store would otherwise need apps for. {on} of {total} are on. Turn one on, set its options, then style it in the theme editor.",
  "feat.read_only": "You can see which features are on. Ask the store owner to change them.",
  "feat.search": "Search features",
  "feat.category.shopping": "Shopping",
  "feat.category.shopping_hint": "Help customers find and choose products.",
  "feat.category.conversion": "Conversion",
  "feat.category.conversion_hint": "Turn more visits into orders.",
  "feat.category.orders": "Orders",
  "feat.category.orders_hint": "After the purchase: confirmation, tracking, returns.",
  "feat.category.engagement": "Engagement",
  "feat.category.engagement_hint": "Keep customers coming back.",
  "feat.locked": "Turned off by Sooquna",
  "feat.upgrade": "Upgrade plan",
  "feat.needs_other": "Needs another feature",
  "feat.options": "Options",
  "feat.customise": "Customise",
  "feat.manage": "Manage",
  "feat.see_plans": "See plans",
  "feat.turned_on": "{name} is on.",
  "feat.turned_off": "{name} is off.",
  "feat.options_title": "{name} options",
  "feat.options_note": "Colours, labels and placement are set in the theme editor.",
  "feat.open_features": "Open features",
  "feat.off_banner": "{name} is off. Customers don't see it until you turn it on.",

  "feat.wishlist.name": "Wishlist",
  "feat.wishlist.description": "Customers save products for later with a heart on product pages and cards. Saved to their account, or in the browser for guests.",
  "feat.wishlist.guest_wishlist": "Guests can save products",
  "feat.wishlist.guest_wishlist_hint": "Kept in their browser and moved to their account when they sign in.",
  "feat.wishlist.max_items": "Most products per wishlist",
  "feat.wishlist.max_items_hint": "Between 10 and 500.",
  "feat.product_search.name": "Search and filters",
  "feat.product_search.description": "Instant search suggestions as customers type, and filters by price, availability, options and more.",
  "feat.variants_display.name": "Variant swatches",
  "feat.variants_display.description": "Colour and image swatches for options, with the price, stock and photo of the chosen variant.",
  "feat.reviews.name": "Product reviews",
  "feat.reviews.description": "Star ratings and reviews on products, with verified-buyer badges. You approve reviews before they show.",
  "feat.reviews.auto_publish": "Publish without approval",
  "feat.reviews.auto_publish_hint": "Reviews you don't publish automatically wait for you under Reviews.",
  "feat.reviews.auto_publish.off": "Never: I approve every review",
  "feat.reviews.auto_publish.four_plus": "4 and 5 star reviews",
  "feat.reviews.auto_publish.all": "All reviews",
  "feat.reviews.verified_only": "Only buyers can review",
  "feat.reviews.verified_only_hint": "Reviews need the email of an order that included the product.",
  "feat.reviews.request_email": "Ask buyers for a review",
  "feat.reviews.request_email_hint": "Emails customers after their order is delivered.",
  "feat.reviews.request_delay_days": "Days after delivery",
  "feat.reviews.request_delay_days_hint": "When the review request goes out.",
  "feat.related_products.name": "Related and recently viewed",
  "feat.related_products.description": "\"You may also like\" on product pages, and the products a customer looked at recently.",
  "feat.related_products.recently_viewed": "Show recently viewed",
  "feat.related_products.recently_viewed_hint": "Remembered in the customer's browser.",
  "feat.back_in_stock.name": "Back-in-stock alerts",
  "feat.back_in_stock.description": "Customers ask to be told when a sold-out product is back. They're messaged as soon as it's in stock.",
  "feat.back_in_stock.whatsapp": "Offer WhatsApp alerts",
  "feat.back_in_stock.whatsapp_hint": "When your WhatsApp number is connected in Notifications.",
  "feat.back_in_stock.min_quantity": "Alert when stock reaches",
  "feat.back_in_stock.min_quantity_hint": "Units available before alerts go out.",
  "feat.abandoned_cart.name": "Abandoned checkout recovery",
  "feat.abandoned_cart.description": "Reminds customers who left checkout, with a link back to their cart and an optional discount.",
  "feat.abandoned_cart.audience": "Who gets reminders",
  "feat.abandoned_cart.audience_hint": "Reminders to customers who haven't agreed to marketing may not be allowed everywhere.",
  "feat.abandoned_cart.audience.all": "Everyone who left an email or phone",
  "feat.abandoned_cart.audience.subscribed": "Only customers subscribed to marketing",
  "feat.abandoned_cart.step1_hours": "First reminder after (hours)",
  "feat.abandoned_cart.step1_hours_hint": "Hours after the customer left checkout.",
  "feat.abandoned_cart.step2_hours": "Second reminder after (hours)",
  "feat.abandoned_cart.step2_hours_hint": "0 sends no second reminder.",
  "feat.abandoned_cart.step3_hours": "Third reminder after (hours)",
  "feat.abandoned_cart.step3_hours_hint": "0 sends no third reminder.",
  "feat.abandoned_cart.discount_percent": "Discount in a reminder (%)",
  "feat.abandoned_cart.discount_percent_hint": "A one-time code that expires after 48 hours. 0 gives no discount.",
  "feat.abandoned_cart.discount_step": "Reminder with the discount",
  "feat.abandoned_cart.discount_step_hint": "1, 2 or 3.",
  "feat.abandoned_cart.whatsapp": "Also remind on WhatsApp",
  "feat.abandoned_cart.whatsapp_hint": "When your WhatsApp number is connected and the customer gave a phone number.",
  "feat.discounts_storefront.name": "Discounts on the storefront",
  "feat.discounts_storefront.description": "Discount code field in the cart, automatic discounts and a free-shipping progress bar.",
  "feat.discounts_storefront.free_shipping_threshold": "Free shipping from",
  "feat.discounts_storefront.free_shipping_threshold_hint": "Shown in the progress bar. Leave 0 to use your free-shipping rate.",
  "feat.cod_confirmation.name": "Cash on delivery confirmation",
  "feat.cod_confirmation.description": "Customers confirm cash on delivery orders by email or WhatsApp before you ship, so fewer orders are refused at the door.",
  "feat.cod_confirmation.hold_fulfillment": "Hold until confirmed",
  "feat.cod_confirmation.hold_fulfillment_hint": "Unconfirmed orders can't be fulfilled until the customer or you confirm them.",
  "feat.cod_confirmation.whatsapp": "Ask on WhatsApp",
  "feat.cod_confirmation.whatsapp_hint": "When your WhatsApp number is connected and the customer gave a phone number.",
  "feat.cod_confirmation.reminder_hours": "Remind after (hours)",
  "feat.cod_confirmation.reminder_hours_hint": "0 sends no reminder.",
  "feat.cod_confirmation.auto_cancel_hours": "Cancel unconfirmed orders after (hours)",
  "feat.cod_confirmation.auto_cancel_hours_hint": "0 never cancels them automatically.",
  "feat.whatsapp_share.name": "WhatsApp sharing and chat",
  "feat.whatsapp_share.description": "Share buttons on products and a WhatsApp chat button that opens a conversation with your store.",
  "feat.order_notifications.name": "WhatsApp order updates",
  "feat.order_notifications.description": "Order confirmations, shipping and delivery updates on WhatsApp, as well as email.",
  "feat.product_badges.name": "Product badges",
  "feat.product_badges.description": "New, sale, bestseller, low stock and sold out badges on product cards and pages.",
  "feat.product_badges.bestseller_count": "Bestsellers",
  "feat.product_badges.bestseller_count_hint": "How many top-selling products get the badge.",
  "feat.product_badges.bestseller_days": "Bestsellers over (days)",
  "feat.product_badges.bestseller_days_hint": "Sales counted over this many days.",
  "feat.announcement_bar.name": "Announcement bar",
  "feat.announcement_bar.description": "Messages above the header, with start and end dates, countries and a close button.",
  "feat.newsletter_capture.name": "Newsletter sign-up",
  "feat.newsletter_capture.description": "Sign-up forms and an optional pop-up. Subscribers join your customers with marketing consent.",
  "feat.stock_status.name": "Stock status",
  "feat.stock_status.description": "In stock, low stock and sold out on product pages and cards.",
  "feat.size_guide.name": "Size guide",
  "feat.size_guide.description": "A size guide link on product pages that opens your size chart, by product type or per product.",
  "feat.order_tracking.name": "Order tracking",
  "feat.order_tracking.description": "Customers look up an order by number and email or phone, and see its status and tracking.",
  "feat.returns_requests.name": "Return requests",
  "feat.returns_requests.description": "Customers request returns or exchanges from their account. You approve them under Orders.",
  "feat.returns_requests.window_days": "Return window (days)",
  "feat.returns_requests.window_days_hint": "Days after delivery a return can be requested.",
  "feat.returns_requests.reasons": "Return reasons",
  "feat.returns_requests.reasons_hint": "Customers pick one. Press Enter after each.",
  "feat.returns_requests.exchanges": "Allow exchanges",
  "feat.returns_requests.exchanges_hint": "Customers can ask for another size or colour instead of a refund.",
  "feat.reorder.name": "Buy again",
  "feat.reorder.description": "A \"Buy again\" button on past orders that puts the same products back in the cart.",
  "feat.gift_cards.name": "Gift cards",
  "feat.gift_cards.description": "Sell gift cards, email them to the recipient, and accept them as payment at checkout.",
  "feat.gift_cards.expiry_months": "Gift cards expire after (months)",
  "feat.gift_cards.expiry_months_hint": "0 means they never expire. Check the rules where you sell.",
  "feat.gift_message.name": "Gift messages",
  "feat.gift_message.description": "Customers mark an order as a gift and add a message at checkout.",
  "feat.gift_message.max_length": "Longest message (characters)",
  "feat.gift_message.max_length_hint": "Between 20 and 1000.",
  "feat.quick_view.name": "Quick view",
  "feat.quick_view.description": "Open a product from a collection in a pop-up and add it to the cart without leaving the page.",
  "feat.image_zoom.name": "Image zoom",
  "feat.image_zoom.description": "Customers zoom into product photos on the product page.",
} as const;

export default featuresEn;
